import { styled } from "@mui/material";

import { DrawerMenuItem } from "@/Components/v2/molecule/DrawerMenuItem.tsx";

import { MenuListGroup } from "./Drawer";

const MenuGroup = ({
  group,
  isSelected,
}: {
  group: MenuListGroup;
  isSelected: (activePaths: string[]) => boolean;
}) => {
  if (!group.items.some((item) => item.hasAccess)) return null;
  return (
    <StyledDiv>
      {group.label && <StyledGroupLabel>{group.label}</StyledGroupLabel>}
      {group.items.map((item) => {
        if (!item.hasAccess) return null;

        return <DrawerMenuItem key={item.id} selected={isSelected(item.activePaths)} {...item} />;
      })}
    </StyledDiv>
  );
};

const StyledDiv = styled("div")(() => ({}));

const StyledGroupLabel = styled("div")(() => ({
  fontSize: ".875rem",
  lineHeight: "1rem",
  textTransform: "uppercase",
  fontWeight: 600,
  padding: "8px 0",
}));

export default MenuGroup;
